export const GET_DEFAULTREVENUEGROUPS = 'GET_DEFAULTREVENUEGROUPS'
export const GET_DEFAULTREVENUEGROUPS_SUCCESS = 'GET_DEFAULTREVENUEGROUPS_SUCCESS'
export const GET_DEFAULTREVENUEGROUPS_FAILED = 'GET_DEFAULTREVENUEGROUPS_FAILED'
